


















import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import TabsNavigation from '@/componentsV2/molecules/TabsNavigation/TabsNavigation.vue';
import GeneralInfo from './Tabs/GeneralInfo.vue';
import HoursOfOperation from './Tabs/HoursOfOperation.vue';
import flagKeys from '@/constants/flagKeys';
import segmentIo from '@/utils/segment.io';
import { IBusinessType } from '@/models/business';

const GENERAL_INFO_TAB = 'GeneralInfo';

@Component({
  components: {
    Page,
    Typography,
    GeneralInfo,
    HoursOfOperation,
    TabsNavigation
  }
})
export default class BusinessProfileRoot extends Vue {
  // Class fields run on a proxy without `_i18n`, so reading the translated
  // `tabs` getter here would throw inside `data()` and blank the page.
  activeTabValue = GENERAL_INFO_TAB;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get openingHoursIsActive() {
    return this.flags.includes(flagKeys.openingHours);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get tabs() {
    const tabs = [
      {
        label: String(this.$t('business.businessProfile.tabs.generalInfo')),
        value: GENERAL_INFO_TAB
      }
    ];

    if (
      this.openingHoursIsActive &&
      this.businessInfo.type !== IBusinessType.ONLINE
    )
      tabs.push({
        label: String(this.$t('business.businessProfile.tabs.operatingHours')),
        value: 'HoursOfOperation'
      });
    return tabs;
  }

  changeTab(value: { label: string; value: string }) {
    segmentIo.track('Business Info | Changed Tab', {
      To: value.value,
      From: this.activeTabValue
    });
    this.activeTabValue = value.value;
  }

  created() {
    if (
      this.$route.query.tab &&
      this.tabs.filter(tab => tab.value === this.$route.query.tab)[0]
    ) {
      this.activeTabValue = this.$route.query.tab as string;
    }
  }
}
